/*global ADMIN_ROOT_URL, ALLOW_CORS, PRODUCT_NAME */
/*
 * Properties file for the Authoring Tool
 */

define([], function () {
  "use strict";

  return {
    //default language
    defaultLanguage: "en",
    fallbackLanguage: "en",
    // URL root for global and landlord administration sections
    adminRootURL: ADMIN_ROOT_URL,
    //URL root
    rootURL: `${ADMIN_ROOT_URL}/kbs`,
    showLandlords: false,
    oauthClientId: "ak",
    applicationName: PRODUCT_NAME,
    mixpanelProductName: "KNO",
    mixpanelToken: "",
    loginMethod: "redirect",
    linkDefaultProtocol: "https://",
    uploadUrl: `${ADMIN_ROOT_URL}/content/upload`,
    generatedExamplesMaxAllowedSelection: 3,
    allowCors: ALLOW_CORS,
    emergingTopicsThreshold: 25,
    clusteringJobQueryCountThreshold: 1000,
  };
});
